import React, { useState, useEffect, useRef, useContext } from 'react';
import { requester } from "App";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import InputNumber from 'components/inputs/signUp/InputNumber';
import CustomButton from 'components/buttons/CustomButton';
import { AuthContext } from 'providers/AuthProvider';
import { toast } from 'react-toastify';
import style from "./VendorOrderRequest.module.css";

function VendorOrderRequest() {
    const numberRef = useRef();
    const [products, setProducts] = useState([]);
    const [quantities, setQuantities] = useState({}); // 각 상품의 수량을 관리하는 상태
    const { userName } = useContext(AuthContext);

    useEffect(() => {
        let data = { storeId: "root" };
        requester.findAllProducts(data, (result) => {
            
            setProducts(result.data);
            const initialQuantities = {};
            if (result.code === 0) {
                result.data.forEach(product => {
                    initialQuantities[product.id] = 0; // 초기 수량을 0으로 설정
                });
            }

            setQuantities(initialQuantities);
        });
    }, []);

    // handleQuantityChange 함수 수정
    const handleQuantityChange = (productId, newQuantity) => {
        const product = products.find(p => p.id === productId);
        const maxQuantity = product ? product.quantity : 0;

        if (newQuantity < 0) {
            newQuantity = 0; // 최소값은 0
        } else if (newQuantity > maxQuantity) {
            newQuantity = maxQuantity; // 최대 수량을 초과하지 않도록 함
        }

        setQuantities(prevQuantities => ({
            ...prevQuantities,
            [productId]: newQuantity
        }));
    };
    // "+" 버튼 클릭 핸들러
    const incrementQuantity = (productId) => {
        const currentQuantity = quantities[productId] || 0;
        handleQuantityChange(productId, currentQuantity + 1);
    };

    // "-" 버튼 클릭 핸들러
    const decrementQuantity = (productId) => {
        const currentQuantity = quantities[productId] || 0;
        handleQuantityChange(productId, currentQuantity - 1);
    };

    // 수량 변경 함수
    const updateQuantity = (productId, delta) => {
        setQuantities((prevQuantities) => {
            const currentQuantity = prevQuantities[productId] || 0;
            let updatedQuantity = currentQuantity + delta;

            // 최소값 0과 최대값 사이로 조정
            updatedQuantity = Math.max(0, updatedQuantity);

            return {
                ...prevQuantities,
                [productId]: updatedQuantity,
            };
        });
    };

    useEffect(() => {
        const data = { storeId: "root" };
        requester.findAllProducts(data, (result) => {
            
            setProducts(result.data);
        });
    }, []);

    // 중첩된 객체 포함 모든 키를 추출하는 함수 (특정 키 제외)
    const extractHeaders = (data) => {
        const excludedKeys = ['storeId', 'categoryId', 'brandId', 'vendorId', 'id']; // 제외할 키 목록
        const headersSet = new Set();
        data && data.forEach(item => {
            Object.keys(item).forEach(key => {
                if (!excludedKeys.includes(key)) {
                    headersSet.add(key);
                }
            });
        });
        return Array.from(headersSet);
    };

    const headers = extractHeaders(products);

    // 중첩된 데이터 접근 함수
    const getNestedValue = (item, path) => {
        const keys = path.split('.');
        let result = item;
        for (let key of keys) {
            result = result[key] || "";
        }
        return result;
    };

    const getOrderProducts = () => {
        // 수량이 조절된 상품들만 필터링
        const adjustedProducts = products.filter(product => quantities[product.id] > 0);

        // 각 상품의 정보와 조절된 수량을 포함하는 객체 생성
        const orderProducts = adjustedProducts.map(product => ({
            ...product,
            requestQuantity: quantities[product.id]
        }));

        return orderProducts;
    };



    // 예시: 발주 요청을 처리하는 함수
    const handleOrderRequest = () => {
        const orderProducts = getOrderProducts();

        let data = { storeId: "root", vendorId: userName, deliveryType: "WaitingForPayment", orderRequestProducts: orderProducts}
        if(orderProducts.length > 0){
            requester.createOrderRequest(data, (result) => {
                if(result.code === 0) {
                    toast.success("발주요청이 완료되었습니다.", {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            })
        }else{
            toast.error("발주할 상품의 수량을 선택해주세요", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        }

        
        
        // 여기에서 orderProducts를 사용하여 서버에 발주 요청을 보내거나 다른 처리를 수행
    };

    const styles = {
        // 기존 스타일 유지
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            boxShadow: '0 2px 3px rgba(0, 0, 0, 0.1)',
        },
        th: {
            backgroundColor: '#f0f0f0',
            color: '#333',
            fontWeight: 'bold',
            padding: '10px',
            border: '1px solid #ccc',
            textAlign: 'left',
        },
        td: {
            padding: '8px',
            border: '1px solid #ccc',
            textAlign: 'left',
        },
        input: {
            width: '40%',
            textAlign: 'center',

        },
        // 버튼 스타일 업데이트
        button: {
            // padding: '5px 8px',

            backgroundColor: '#4CAF50', // 녹색 배경
            color: 'white', // 흰색 글씨
            border: 'none',
            borderRadius: '50%', // 둥근 모서리
            cursor: 'pointer',
            fontSize: '16px',
        },
        // 수량 조절 버튼 스타일
        quantityButton: {
            backgroundColor: 'var(--main-color)', // 빨간색 배경
        },
    };

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }

    return (
        <VerticalFlex gap={30}>
            <FlexChild>
                <P size={40} font={"gmarketSansBold"}>상품 발주요청</P>
            </FlexChild>
            <FlexChild>
                <div style={{ overflowX: 'auto' }}>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                {headers.map((header) => (
                                    <th style={styles.th} key={header}>{header}</th>
                                ))}
                                <th style={styles.th}>수량</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products && products.map((product, index) => (
                                <tr key={index}>
                                    {headers && headers.map((header) => (
                                        <td style={styles.td} key={`${index}-${header}`}>
                                            {header.endsWith('Img') ? (
                                                <img src={getNestedValue(product, header)} alt="Product" style={{ maxWidth: '100px', maxHeight: '100px' }} />
                                            ) : (
                                                getNestedValue(product, header)
                                            )}
                                        </td>
                                    ))}
                                    <td style={styles.td} className={style.inputNumber}>
                                        <button style={{ ...styles.button, ...styles.quantityButton }} onClick={() => decrementQuantity(product.id)}>-</button>
                                        <input
                                            type="number"
                                            style={styles.input}
                                            value={quantities[product.id] || 0}
                                            onChange={(e) => handleQuantityChange(product.id, parseInt(e.target.value, 10))}
                                            min={0}
                                            max={product.quantity}
                                        />
                                        <button style={{ ...styles.button, ...styles.quantityButton }} onClick={() => incrementQuantity(product.id)}>+</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </FlexChild>
            <FlexChild>
                <CustomButton text={"상품발주요청"} onClick={handleOrderRequest} />
            </FlexChild>
        </VerticalFlex>
    );
}

export default VendorOrderRequest;